import { ComposeViewState } from 'owa-mail-compose-store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import disableClientSignatureOnReply from '../../actions/disableClientSignatureOnReply';
import disableClientSignatureOnNew from '../../actions/disableClientSignatureOnNew';
import { lazyinsertSignature } from 'owa-mail-compose-actions';
import { ComposeTypeResponse } from 'owa-addins-types';
import { ComposeType } from 'owa-editor-addin-plugin-types/lib/utils/AddinViewState';

export const getComposeTypeAndCoercionType = (
    viewState: ComposeViewState
) => (): ComposeTypeResponse => {
    let response: ComposeTypeResponse;
    let composeType: string = 'newMail';
    if (viewState.addin.draftComposeType === ComposeType.Reply) {
        composeType = 'reply';
    }
    if (viewState.addin.draftComposeType === ComposeType.Forward) {
        composeType = 'forward';
    }
    if (viewState.addin.draftComposeType === ComposeType.New) {
        composeType = 'newMail';
    }
    response = {
        coercionType: viewState.bodyType.toLowerCase(),
        composeType: composeType,
    };

    return response;
};

export const setSignature = (viewState: ComposeViewState) => async (signature: string) => {
    const insertSignature = await lazyinsertSignature.import();
    insertSignature(viewState, signature);
};

export const isClientSignatureEnabled = () => (): boolean => {
    const userOption = getUserConfiguration().UserOptions;
    const isNativeSignatureEnabled: boolean =
        userOption.AutoAddSignature || userOption.AutoAddSignatureOnReply;
    return isNativeSignatureEnabled;
};

export const disableClientSignature = () => (): Promise<boolean> => {
    return new Promise<boolean>((resolve, reject) => {
        const userOption = getUserConfiguration().UserOptions;
        let isClientSignatureEnabled: boolean = false;
        if (userOption.AutoAddSignature) {
            disableClientSignatureOnNew();
            isClientSignatureEnabled = true;
        }
        if (userOption.AutoAddSignatureOnReply) {
            disableClientSignatureOnReply();
            isClientSignatureEnabled = true;
        }
        return resolve(isClientSignatureEnabled);
    });
};
